import {
  Section,
  Intro,
  ToolLink,
  ToolGrid,
  Button,
} from "./styled";

const paths = [
  {
    number: "01",
    eyebrow: "Planuję zakup",
    title: "Najpierw policz budżet",
    text: "Sprawdź koszty zakupu i przygotuj dane, które później wykorzystamy przy analizie finansowania.",
    tools: [
      { label: "Rata i wkład własny", description: "Porównaj 10%, 20% wkładu i RKM oraz zobacz orientacyjną ratę.", href: "/kalkulator-rata-wklad" },
      { label: "Koszty transakcyjne", description: "Sprawdź gotówkę potrzebną poza wkładem własnym.", href: "/narzedzia/?view=costs" },
    ],
  },
  {
    number: "02",
    eyebrow: "Mam już kredyt",
    title: "Sprawdź, co można poprawić",
    text: "Porównaj nadpłatę z refinansowaniem. Wynik kalkulatora jest początkiem analizy, a nie obietnicą oszczędności.",
    featured: true,
    tools: [
      { label: "Nadpłata kredytu", description: "Porównaj obniżenie raty ze skróceniem okresu i odsetkami.", href: "/kalkulator-nadplat" },
      { label: "Refinansowanie", description: "Sprawdź ratę, okres, koszty zmiany i możliwe oszczędności.", href: "/narzedzia/?view=refi" },
    ],
  },
  {
    number: "03",
    eyebrow: "Przygotowuję transakcję",
    title: "Uporządkuj dokumenty",
    text: "Przygotuj roboczy projekt umowy i sprawdź elementy, które mogą mieć znaczenie dla banku i terminów transakcji.",
    tools: [
      { label: "Umowa przedwstępna", description: "Uporządkuj dane, sposób płatności i terminy ważne dla kredytu.", href: "/narzedzia/?view=agreement" },
      { label: "Checklisty dokumentów", description: "Wybierz listę dla rynku wtórnego, dewelopera, budowy domu albo refinansowania.", href: "/checklisty" },
    ],
  },
];

const Narzedzia = () => (
  <ToolsSection />
);

const ToolsSection = () => {
  return <Section id="narzedzia">
    <Intro>
      <span>Bezpłatne narzędzia Serce Finansów</span>
      <h2>Policz i przygotuj się</h2>
      <p>Wybierz kalkulator lub dokument potrzebny do kolejnego kroku. Bez zakładania konta i podawania danych kontaktowych.</p>
    </Intro>
    <ToolGrid aria-label="Bezpłatne kalkulatory i dokumenty">
            {paths.flatMap(path => path.tools).map((tool) => (
              <ToolLink key={tool.label} href={tool.href} target="_blank" rel="noopener noreferrer">
                <img src={`/tool-icons/${({"Rata i wkład własny":"payment","Koszty transakcyjne":"costs","Nadpłata kredytu":"overpayment","Refinansowanie":"refinance","Umowa przedwstępna":"agreement","Checklisty dokumentów":"checklist"})[tool.label]}.svg`} width="40" height="40" alt="" />
                <div><strong>{tool.label}</strong><small>{tool.description}</small></div><span aria-hidden="true">→</span>
              </ToolLink>
            ))}
    </ToolGrid>
    <Button href="/narzedzia/" target="_blank" rel="noopener noreferrer">Zobacz wszystkie narzędzia</Button>
  </Section>;
};

export default Narzedzia;

